import { FileText, Download } from 'react-feather'
import { t } from '@lingui/core/macro'

import { MeetingLinkOrder } from '@/core/graphql/types'
import { Card } from '@/components/ui/card'

export function DocumentsCard({ files, filesLabel }: { files: NonNullable<MeetingLinkOrder['files']>; filesLabel: string }) {
  return (
    <Card className="rounded-2xl border-gray-200 p-6 shadow-sm">
      <div className="mb-5 flex items-center gap-2.5">
        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary/10 text-primary">
          <FileText size={18} aria-hidden="true" />
        </span>
        <h3 className="text-lg font-semibold text-gray-900">{filesLabel.replace('{count}', files.length.toString())}</h3>
      </div>
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        {files.map((file) => (
          <a
            key={file.key}
            href={file.url || '#'}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-3 rounded-xl border border-gray-200 p-3 transition-all hover:border-primary/40 hover:bg-primary/5"
          >
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
              <FileText size={20} />
            </div>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-gray-900 group-hover:text-primary">{file.filename}</p>
              <p className="text-xs text-gray-500">{t`Document`}</p>
            </div>
            <Download size={16} className="shrink-0 text-gray-300 transition-colors group-hover:text-primary" aria-hidden="true" />
          </a>
        ))}
      </div>
    </Card>
  )
}
